export const EQUIPMENT_TYPES_FETCHED = 'EQUIPMENT_TYPES_FETCHED';
export const EQUIPMENT_TYPE_ADDED = 'EQUIPMENT_TYPE_ADDED';
export const EQUIPMENT_TYPE_UPDATE = 'EQUIPMENT_TYPE_UPDATE';
